import React, {useState} from "react";
import {connect} from "react-redux";
import {Dropdown, HelpIcon} from "../../../../components";
import {withCommands} from "./CommandsProvider";
import * as at from "../actionTypes";

const priorities = [{
  label: "Extra High", value: "extrahigh"
}, {
  label: "High", value: "high"
}, {
  label: "Medium", value: "medium"
}, {
  label: "Low", value: "low"
}, {
  label: "ExtraLow", value: "extralow"
}];

export function UnconnectedJobQueueDialog({
  commands,
  selectedCount,
  queueJobsRequested,
  queueJobsSummary,
  dispatch
}) {
  const [priority, setPriority] = useState("medium");
  const [jumpQueue, setJumpQueue] = useState(false);
  const [skipRequirements, setSkipRequirements] = useState(false);
  const disabled = queueJobsRequested || !priority || selectedCount === 0;
  const selectedPriority = priorities.find(x => x.value === priority);
  return queueJobsSummary ? <div className={`alert alert-${queueJobsSummary.status} clearfix alert-dismissable`}>
    <a
      onClick={() => dispatch({ type: at.CLEAR_QUEUED_STATUS }) }
      className="close">&times;</a>
    {queueJobsSummary.message}

  </div> :
    <div className="alert alert-info clearfix">
      <h4>Queue Jobs</h4>
      <p>{selectedCount} Job{selectedCount === 1 ? '' : 's'} Selected</p>
      <div className="form-inline">
        <div className="form-check form-check-inline">
          <input
            id="jumpQueue"
            className="form-check-input"
            checked={jumpQueue}
            onChange={() => setJumpQueue(!jumpQueue)}
            type="checkbox" />
          <label className="form-check-label" htmlFor="jumpQueue">
            To Front of Queue <HelpIcon message={`Cuts the line, and sends the job to the front of the queue (higher priority jobs will still run first).`} />
          </label>
        </div>
        &nbsp;&nbsp;
        <div className="form-check form-check-inline">
          <input
            className="form-check-input"
            checked={skipRequirements}
            id="skipRequirements"
            onChange={() => setSkipRequirements(!skipRequirements)}
            type="checkbox" />
          <label className="form-check-label" htmlFor="skipRequirements">
            Ignore Requirements <HelpIcon message={
              `Some jobs have pre-conditions that must be met before they are queued. For example email alerts jobs only queue for locations that have email alerts enabled, or listings jobs only run if the tab is visible. This option will override all requirements.`
            } />
          </label>
        </div>
        <Dropdown
          style={{display: 'inline-block', margin: '0 5px'}}
          items={priorities}
          renderItem={opt => opt ? opt.label : <span className="text-muted">Select ...</span>}
          onSelected={opt => setPriority(opt.value)}
          selected={selectedPriority}
        />
        <a
          className={`btn btn-secondary ${disabled ? 'disabled' : ''}`}
          tabIndex={0}
          onClick={() => !disabled && commands.queue({
              priority, jumpQueue, skipRequirements
            })
          }
        >
          {queueJobsRequested && <span className="fas fa-spinner fa-spin" />} Queue
        </a>
      </div>
    </div>
}


export const JobQueueDialog = withCommands(connect(function mapStateToProps(state, ownProps) {
  const { queueJobsRequested, queueJobsSummary, selectedCount } = state.manageTool;
  return {
    ...ownProps,
    selectedCount, queueJobsRequested, queueJobsSummary
  }
})(UnconnectedJobQueueDialog))
